/** Транслітерація українських літер (офіційна, спрощена для ключів). */
const MAP: Record<string, string> = {
  а: 'a', б: 'b', в: 'v', г: 'h', ґ: 'g', д: 'd', е: 'e', є: 'ie', ж: 'zh', з: 'z', и: 'y', і: 'i', ї: 'i', й: 'i', к: 'k', л: 'l', м: 'm', н: 'n',
  о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'kh', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'shch', ь: '', ю: 'iu', я: 'ia', '’': '', "'": '',
};

/**
 * Ключ нового власного поля з підпису (ADR-023: `cf_[a-z0-9_]{2,40}`, унікальний серед полів типу): транслітерація, малі латинські літери,
 * цифри й «_»; закороткий — «field»; повтор — «_2», «_3»… Чиста функція.
 */
export function customFieldKey(label: string, taken: Iterable<string>): string {
  const used = new Set(taken);
  const slug = [...label.toLowerCase()].map((c) => MAP[c] ?? c).join('').replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 34);
  const base = `cf_${slug.length >= 2 ? slug : 'field'}`;
  let key = base;
  for (let n = 2; used.has(key); n += 1) key = `${base}_${n}`;
  return key;
}
